import { trackInternalEvent } from '@rio/tracking'
import { useOnboarding } from '../hooks/useOnboarding'
import { useOnboardingActions } from '../hooks/useOnboardingActions'

import { Variant } from '../types'
import { Nav } from '../components/Nav/Nav'
import { Steps } from './Steps/Steps'
import { Container } from './styles'

type Props = {
  variant: Variant
}

export const Onboarding = ({ variant }: Props) => {
  const { resume, isAiResumePending, isAiResumeFailed } = useOnboarding()
  const { onFinishClick } = useOnboardingActions(resume)
  const isAiResumeLoading = isAiResumePending || isAiResumeFailed

  const onHandleSkip = () => {
    trackInternalEvent('leads_onboarding_skip')
    onFinishClick()
  }

  return (
    <Container data-testid="provision-users-onboarding">
      <Nav onLinkClick={onHandleSkip} />
      <Steps
        variant={variant}
        resume={resume}
        isAiResumeLoading={isAiResumeLoading}
        onFinishClick={onFinishClick}
      />
    </Container>
  )
}
